import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment-timezone';
import DatePicker from 'react-date-picker';
import TimePicker from 'react-time-picker';
import {BootstrapForm, FormGroup} from '../bootstrap/Form';
import {setTrialExpiry} from '../../actions/ClientActions';
import Modal from '../../components/Modal';

@connect(
    state => ({
        isSavingTrialPeriod: state.modal.isSavingTrialPeriod
    })
)
export default class ExtendTrialModal extends Component {

	constructor(props){
		super(props);
		this.state = {
			trialExpiresAt : props.client.trialExpiresAt,
            signedUpAt : props.client.signedUpAt,
            datePickerVisible : false
		}
	}

    handleSubmit(e) {
        e.preventDefault();
        this.saveTrial();
    }

    handleChange(e) {
        this.setState({trialExpiresAt : e.target.value});
    }

    saveTrial() {
        this.props.dispatch(setTrialExpiry({
            clientId : this.props.client.id,
            trialExpiresAt : moment(this.state.trialExpiresAt),
        }));
    }

    dateClick(e){
        console.log('dateclick', e);
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            datePickerVisible : ! this.state.datePickerVisible
        });
    }

    dateChange(dateString, _moment){        
        console.log("date string", dateString);
        this.setState({
            trialExpiresAt : dateString,
            datePickerVisible : false
        })
    }

    timeChange(time){
        const splitTime = time.split(":");
        let t = moment(this.state.trialExpiresAt).set({
            'hour': splitTime[0],
            'minute': splitTime[1],
            'second': splitTime[2]
        });
        this.setState({trialExpiresAt:t})
    }

    blurDate(e){
        e.preventDefault();
        console.log('blurDate');
        this.setState({
            datePickerVisible : false
        })
    }

    render() {

        var actionButton = this.props.isSavingTrialPeriod ?
            (<button className="btn btn-success disabled">Extending Trial...</button>) :
            (<button className="btn btn-success" onClick={this.saveTrial.bind(this)}>Save Trial Date</button>);

        return (
           <Modal actionButton={actionButton} className="modal modal-success" title="Edit Trial End Date" onClick={this.blurDate.bind(this)}>
                <BootstrapForm ref="form" onSubmit={this.handleSubmit.bind(this)} style={{overflow : 'hidden'}}>
                    <FormGroup defaultText="Trial expires at">
                        <div>
                            <div className="col-sm-8">
                                <input type="text" style={{marginRight: '6px', cursor : 'pointer', textAlign: 'center'}} readOnly value={moment(this.state.trialExpiresAt).format("DD/MM/YYYY")} onClick={this.dateClick.bind(this)} />
                                {this.state.datePickerVisible &&
                                    <a onClick={this.blurDate.bind(this)} href="#">Cancel</a>
                                }
                                {this.state.datePickerVisible &&
                                    <DatePicker
                                    minDate={moment(this.state.signedUpAt).format("YYYY-MM-DD")}
                                    date={moment(this.state.trialExpiresAt).format("YYYY-MM-DD")} 
                                    onChange={this.dateChange.bind(this)} />
                                }
                            </div>
                        </div>
                    </FormGroup>
                    <FormGroup defaultText="Time" >
                        <div style={{paddingTop: 10}}>
                            <div className="col-sm-8">
                                {<TimePicker 
                                    value={moment(this.state.trialExpiresAt)} 
                                    onChange={this.timeChange.bind(this)}
                                />}
                            </div>
                        </div>
                    </FormGroup>
                </BootstrapForm>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/clients/ExtendTrialModal.js